import React from 'react';

const IconDownload = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.662 17.546h17M5 11l5 5 5-5M10 2v13" stroke="#111" strokeWidth="1.5" />
  </svg>
);
export default IconDownload;
